exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".contenedorTotal{padding:0;background-color:#f8f8ff}.contenedorNavegacion{padding:0 2% 0 4%;background-color:#f8f8ff}.titulo{padding:5%;border:5px;border-color:#000}.cards{box-shadow:1px 5px 7px 5px rgba(0,0,0,.1);border-left-width:0;padding:15px 50px 30px 55px;border-bottom-width:30px;border-color:15px gray}.panel.panel-default{padding:5%}.dashboard-header section-padding{padding-top:1px;padding-bottom:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79719092","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/componentes/inicializacion.vue
// module id = 401
// module chunks = 0